export const CHECKOUT_META = {
  'summer-70': {
    planGroup: 'crmPagesTierExperiment39',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    theme: 'summerControl70',
    applePay: true,
    orderStyle: 'nLWwnZWpmHI='
  },

  'summer-3-9': {
    planGroup: 'crmPagesTierExperiment39',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    theme: 'summerControl39',
    applePay: true,
    orderStyle: 'nLWwnZWpmHI='
  },

  'summer-6-6': {
    planGroup: 'crmPagesTierExperiment66',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    theme: 'summerControl66',
    applePay: true,
    orderStyle: 'nLWwnZWpmHI='
  },

  'summer-12-12': {
    planGroup: 'crmPagesTierExperiment24',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    theme: 'summerControl24',
    applePay: true,
    orderStyle: 'nLWwnZWpmHI='
  },

  'onboarding-70': {
    planGroup: 'crmPagesTierExperiment39',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    applePay: true
  },

  'onboarding-12-12': {
    planGroup: 'crmPagesTierExperiment24',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    applePay: true
  },

  'onboarding-3-9': {
    planGroup: 'crmPagesTierExperiment39',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    applePay: true
  },

  'onboarding-6-6': {
    planGroup: 'crmPagesTierExperiment66',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    applePay: true
  },

  unlimited: {
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true
  },

  'autumn-12-12': {
    planGroup: 'crmPagesTierExperiment24',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    theme: 'autumnSale1212',
    applePay: true
  },

  'autumn-6-6': {
    planGroup: 'crmPagesTierExperiment66',
    theme: 'autumnSale66',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    applePay: true
  },

  'autumn-70': {
    planGroup: 'crmPagesTierExperiment39',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    theme: 'autumnSale70',
    applePay: true
  },

  'autumn-3-9': {
    planGroup: 'crmPagesTierExperiment39',
    experiment_layer: 'external',
    hasTrial: false,
    auth: false,
    allowSessionAuth: true,
    theme: 'autumnSale39',
    applePay: true
  }
}
